// Resolution of the Project Management (Go backend) API endpoint.
//
// This used to live inline in `src/apiPm.js` as
// `process.env.REACT_APP_PM_API_ENDPOINT || 'https://api-erp.cbqaglobal.co.id'`.
// That default is what turned a deployment gap into an unexplained outage: when
// the dev and staging pipelines stopped injecting REACT_APP_PM_API_ENDPOINT
// (commit f6a9c1e moved staging to Docker Compose and dropped the
// STAGING_REACT_APP_PM_API_ENDPOINT line; deploy-dev.yml was modelled on it and
// never had one), every PM request silently went to another environment's Go
// backend, whose older build answers /api/v1/pm/dashboard/summary with a bare
// 404. Production was unaffected only because it does inject the secret.
//
// A missing endpoint is now reported as a configuration error instead of being
// papered over with a cross-environment host.
export const PM_API_ENDPOINT_ENV_KEY = 'REACT_APP_PM_API_ENDPOINT';

const normalizeEndpoint = (value) => String(value ?? '').trim().replace(/\/+$/, '');

export const resolvePmApiConfig = (env = process.env) => {
  const endpoint = normalizeEndpoint(env?.[PM_API_ENDPOINT_ENV_KEY]);
  if (!endpoint) {
    return { isConfigured: false, endpoint: '', baseURL: '' };
  }
  return { isConfigured: true, endpoint, baseURL: `${endpoint}/api` };
};

export const describePmApiMisconfiguration = () =>
  `Project Management API endpoint is not configured. Set ${PM_API_ENDPOINT_ENV_KEY} for this environment.`;
